import { AppLication } from "./mongeApiMlib";
import customize from "@/CommonDP/mongeCustomize/customize";
// 应用名称集合 方便调用时代码提示
// key 打开应用将自动关闭 "有值同名的key" 的应用--这里我没有用的
// 图纸应用
const appMapList = {
  amplifications: {
    id: 'amplifications',
    cnName: '框选放大',
    icon0: require('./dwgProMax/images/框选放大.png'),
    icon1: require('./dwgProMax/images/框选放大s.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: null
  },
  measure: {
    id: 'measure',
    cnName: '测量',
    icon0: require('./dwgProMax/images/测量.png'),
    icon1: require('./dwgProMax/images/测量s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    isTools: true,
    type: 'dwg',
    component: () => import('./dwgProMax/application/measure.vue')
  },
  pencil: {
    id: 'pencil',
    cnName: '画笔',
    icon0: require('./dwgProMax/images/画笔.png'),
    icon1: require('./dwgProMax/images/画笔s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    isTools: true,
    type: 'dwg',
    component: () => import('./dwgProMax/application/pencil.vue')
  },
  layer: {
    id: 'layer',
    cnName: '图层管理',
    icon0: require('./dwgProMax/images/图层管理.png'),
    icon1: require('./dwgProMax/images/图层管理s.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgProMax/application/layer.vue')
  },
  comparison: {
    id: 'comparison',
    cnName: '版本对比',
    icon0: require('./dwgProMax/images/版本对比.png'),
    icon1: require('./dwgProMax/images/版本对比s.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgProMax/application/comparison.vue')
  },
  overlay: {
    id: 'overlay',
    cnName: '叠图',
    icon0: require('./dwgProMax/images/叠图.png'),
    icon1: require('./dwgProMax/images/叠图s.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgProMax/application/overlay.vue')
  },
  issue: {
    id: 'issue',
    cnName: '创建批注',
    icon0: require('./dwgProMax/images/创建批注.png'),
    icon1: require('./dwgProMax/images/创建批注s.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    payload: "dwg",
    component: () => import('./dwgProMax/application/issue.vue')
  },
  list: {
    id: 'list',
    cnName: '批注列表',
    icon0: require('./dwgProMax/images/批注列表.png'),
    icon1: require('./dwgProMax/images/批注列表s.png'),
    button: 'bottom',
    type: 'dwg',
    key: 'right',
    payload: "dwg",
    component: () => import('./dwgProMax/application/list.vue')
  },
  detail: {
    id: 'detail',
    cnName: '批注详情',
    icon0: null,
    icon1: null,
    button: 'auto',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgProMax/application/detail.vue')
  }
};
// 模型图纸应用
const appModelMapList = {
  amplifications: {
    id: 'amplifications',
    cnName: '框选放大',
    icon0: require('./dwgProMax/images/框选放大.png'),
    icon1: require('./dwgProMax/images/框选放大s.png'),
    button: 'bottom',
    key: 'right',
    type: 'modelDwg',
    component: null
  },
  measure: {
    id: 'measure',
    cnName: '测量',
    icon0: require('./dwgProMax/images/测量.png'),
    icon1: require('./dwgProMax/images/测量s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    type: 'modelDwg',
    isTools: true,
    component: () => import('./dwgProMax/application/measure.vue')
  },
  pencil: {
    id: 'pencil',
    cnName: '画笔',
    icon0: require('./dwgProMax/images/画笔.png'),
    icon1: require('./dwgProMax/images/画笔s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    type: 'modelDwg',
    isTools: true,
    component: () => import('./dwgProMax/application/pencil.vue')
  },
  issue: {
    id: 'issue',
    cnName: '创建批注',
    icon0: require('./dwgProMax/images/创建批注.png'),
    icon1: require('./dwgProMax/images/创建批注s.png'),
    button: 'bottom',
    payload: "modelDwg",
    type: 'modelDwg',
    key: 'right',
    component: () => import('./dwgProMax/application/issue.vue')
  }
};
// 模型应用
const appModelList = {
  amplifications: {
    id: 'amplifications',
    cnName: '框选放大',
    icon0: require('./modelProMax/images/框选放大.png'),
    icon1: require('./modelProMax/images/框选放大s.png'),
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: true,
    component: null
  },
  globe: {
    id: 'globe',
    cnName: '地图',
    icon0: require('./modelProMax/images/地图.png'),
    icon1: require('./modelProMax/images/地图s.png'),
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: false,
    component: null
  },
  modelMeaure: {
    id: 'modelMeaure',
    cnName: '测量',
    icon0: require('./modelProMax/images/测量.png'),
    icon1: require('./modelProMax/images/测量s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: true,
    isTools: true,
    component: () => import('./modelProMax/application/modelMeaure.vue')
  },
  section: {
    id: 'section',
    cnName: '剖切',
    icon0: require('./modelProMax/images/剖切.png'),
    icon1: require('./modelProMax/images/剖切s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: true,
    isTools: true,
    component: () => import('./modelProMax/application/modelSection.vue')
  },
  comparison: {
    id: 'comparison',
    cnName: '版本对比',
    icon0: require('./modelProMax/images/模型对比.png'),
    icon1: require('./modelProMax/images/模型对比s.png'),
    button: 'bottom',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/modelComparison.vue')
  },
  componentColor: {
    id: 'componentColor',
    cnName: '构件颜色',
    icon0: require('./modelProMax/images/构件颜色.png'),
    icon1: require('./modelProMax/images/构件颜色s.png'),
    hasMark: 'down',
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: false,
    isTools: true,
    component: () => import('./modelProMax/application/componentColor.vue')
  },
  modelMini: {
    id: 'modelMini',
    cnName: '小地图',
    icon0: require('./modelProMax/images/小地图.png'),
    icon1: require('./modelProMax/images/小地图s.png'),
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: false,
    isTools: true,
    component: () => import('./modelProMax/application/modelMini.vue')
  },
  roaming: {
    id: 'roaming',
    cnName: '路径漫游',
    icon0: require('./modelProMax/images/漫游.png'),
    icon1: require('./modelProMax/images/漫游s.png'),
    button: 'bottom',
    type: 'model',
    isNolightweight: true,
    key: 'right',
    component: () => import('./modelProMax/application/roaming.vue')
  },
  recorder: {
    id: 'recorder',
    cnName: '录制',
    icon0: require('./modelProMax/images/recorder.png'),
    icon1: require('./modelProMax/images/recorder-s.png'),
    button: 'bottom',
    type: 'model',
    isNolightweight: true,
    key: 'right',
    component: () => import('./modelProMax/application/recorder/index.vue')
  },
  set: {
    id: 'set',
    cnName: '设置',
    icon0: require('./modelProMax/images/设置.png'),
    icon1: require('./modelProMax/images/设置s.png'),
    button: 'bottom',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/set.vue')
  },
  issue: {
    id: 'issue',
    cnName: '创建批注',
    icon0: require('./modelProMax/images/创建批注.png'),
    icon1: require('./modelProMax/images/创建批注s.png'),
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: true,
    payload: "model",
    component: () => import('./modelProMax/application/modelIssue.vue')
  },
  list: {
    id: 'list',
    cnName: '批注列表',
    icon0: require('./modelProMax/images/批注列表.png'),
    icon1: require('./modelProMax/images/批注列表s.png'),
    button: 'bottom',
    key: 'right',
    type: 'model',
    isNolightweight: true,
    payload: "model",
    component: () => import('./dwgProMax/application/list.vue')
  },
  detail: {
    id: 'detail',
    cnName: '批注详情',
    icon0: null,
    icon1: null,
    button: 'auto',
    type: 'model',
    isNolightweight: true,
    key: 'right',
    component: () => import('./modelProMax/application/detail.vue')
  },
  modelTree: {
    id: 'modelTree',
    cnName: '模型树',
    icon0: require('./modelProMax/images/模型树.png'),
    icon1: require('./modelProMax/images/模型树s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/modeltree.vue')
  },
  modelMap: {
    id: 'modelMap',
    cnName: '模型图纸',
    icon0: require('./modelProMax/images/模型图纸.png'),
    icon1: require('./modelProMax/images/模型图纸s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/modelMap.vue')
  },
  areaPlane: {
    id: 'areaPlane',
    cnName: '模型空间',
    icon0: require('./modelProMax/images/空间.png'),
    icon1: require('./modelProMax/images/空间s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/areaPlane.vue')
  },
  modelSystem: {
    id: 'modelSystem',
    cnName: '系统',
    icon0: require('./modelProMax/images/系统.png'),
    icon1: require('./modelProMax/images/系统s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/modelSystem.vue')
  },
  modelAttr: {
    id: 'modelAttr',
    cnName: '属性',
    icon0: require('./modelProMax/images/属性.png'),
    icon1: require('./modelProMax/images/属性s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/modelAttr.vue')
  },
  modelOverlay: {
    id: 'modelOverlay',
    cnName: '二三维叠图',
    icon0: require('./modelProMax/images/二三维叠图.png'),
    icon1: require('./modelProMax/images/二三维叠图s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/modelOverlay.vue')
  },
  modelOverlayTool: {
    id: 'modelOverlayTool',
    cnName: '二三维叠图工具',
    icon0: null,
    icon1: null,
    button: 'auto',
    key: 'right',
    type: 'model',
    isNolightweight: false,
    isTools: true,
    component: () => import('./modelProMax/application/modelOverlayTool.vue')
  },
  collisionDetection: {
    id: 'collisionDetection',
    cnName: '碰撞检测',
    icon0: require('./modelProMax/images/碰撞检测.png'),
    icon1: require('./modelProMax/images/碰撞检测s.png'),
    button: 'left',
    type: 'model',
    isNolightweight: false,
    key: 'right',
    component: () => import('./modelProMax/application/collisionDetection.vue')
  }

};
// 其他预览
const appOtherList = {
  endEdit: {
    id: 'endEdit',
    cnName: '完成编辑',
    icon0: require('./dwgProMax/images/完成编辑-白色.png'),
    icon1: require('./dwgProMax/images/完成编辑-蓝色.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    payload: "other"
  },
  cancelEdit: {
    id: 'cancelEdit',
    cnName: '取消编辑',
    icon0: require('./dwgProMax/images/取消编辑-白色.png'),
    icon1: require('./dwgProMax/images/取消编辑-蓝色.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    payload: "other"
  },
  edit: {
    id: 'edit',
    cnName: '编辑文档',
    icon0: require('./dwgProMax/images/编辑文本1.png'),
    icon1: require('./dwgProMax/images/编辑文本2.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    payload: "other"
  },
  issue: {
    id: 'issue',
    cnName: '创建批注',
    icon0: require('./dwgProMax/images/创建批注.png'),
    icon1: require('./dwgProMax/images/创建批注s.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    payload: "other",
    component: () => import('./docmentView/application/issue.vue')
  },
  list: {
    id: 'list',
    cnName: '批注列表',
    icon0: require('./dwgProMax/images/批注列表.png'),
    icon1: require('./dwgProMax/images/批注列表s.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    payload: "other",
    component: () => import('./docmentView/application/list.vue')
  },
  detail: {
    id: 'detail',
    cnName: '批注详情',
    icon0: null,
    icon1: null,
    button: 'auto',
    key: 'right',
    type: 'other',
    component: () => import('./docmentView/application/detail.vue')
  }
};
// 图纸
export function getMapList() {
  return [
    appMapList.amplifications,
    appMapList.measure,
    appMapList.pencil,
    appMapList.layer,
    appMapList.comparison,
    appMapList.overlay,
    appMapList.issue,
    appMapList.list,
    appMapList.detail,
    ...customize.Map
  ].map((app) => {
    return new AppLication(app);
  });
}
// 模型图纸
export function getModelMapList() {
  return [
    appModelMapList.amplifications,
    appModelMapList.measure,
    appModelMapList.pencil,
    appModelMapList.issue,
    ...customize.ModelMap
  ].map((app) => {
    return new AppLication(app);
  });
}
// 模型列表
export function getModelList() {
  return [
    appModelList.amplifications,
    appModelList.modelMeaure,
    appModelList.section,
    appModelList.comparison,
    appModelList.componentColor,
    appModelList.modelMini,
    appModelList.roaming,
    appModelList.set,
    appModelList.globe,
    appModelList.recorder,
    appModelList.issue,
    appModelList.list,
    appModelList.detail,

    appModelList.modelTree,
    appModelList.modelMap,
    appModelList.areaPlane,
    appModelList.modelSystem,
    appModelList.modelAttr,
    appModelList.modelOverlay,
    appModelList.modelOverlayTool,
    appModelList.collisionDetection,
    ...customize.Model
  ].map((app) => {
    return new AppLication(app);
  });
}
// 非引擎文件
export function getOtherList() {
  return [
    appOtherList.endEdit,
    appOtherList.cancelEdit,
    appOtherList.edit,
    appOtherList.issue,
    appOtherList.list,
    appOtherList.detail,
    ...customize.Other
  ].map((app) => {
    return new AppLication(app);
  });
}
